import { createContext, useContext, type ReactNode } from "react";
import { spanishUi } from "./spanishUi";
export type UiLocale = "en" | "es";
const LocaleContext = createContext<UiLocale>("en");
/** Scoped to a module; portals inherit the locale and unrelated modules keep English. */
export function UiLocaleProvider({ locale, children }: { locale: UiLocale; children: ReactNode }): React.JSX.Element {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}
export function useUiLocale(): UiLocale { return useContext(LocaleContext); }
export function useUiText(): (text: string) => string {
  const locale = useUiLocale();
  return (text) => locale === "es" ? spanishUi[text] ?? text : text;
}
